import { ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';

import { DropdownModule, SidebarModule } from '@coreui/angular-pro';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@infra-adapters/interceptors/auth.interceptor';
import { authErrorInterceptor } from '@infra-adapters/interceptors/authError.interceptor';
import { ApolloClient, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { provideApollo } from 'apollo-angular';
import { setContext } from '@apollo/client/link/context';
import { StorageKeys } from '@core-interfaces/global';
import { environment } from '@infra-env/environment';
import { apolloDefaultOptions } from '@infra-adapters/graphql/apollo-defaults';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
      withHashLocation()
    ),
    importProvidersFrom(SidebarModule, DropdownModule),
    IconSetService,
    provideAnimations(),
    provideHttpClient(
      withInterceptors([authInterceptor, authErrorInterceptor])
    ),
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      const authLink = setContext((_, { headers }) => {
        const token =
          localStorage.getItem(StorageKeys.session_token) ||
          sessionStorage.getItem(StorageKeys.session_token);
        return {
          headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : '',
          },
        };
      });

      const http = httpLink.create({ uri: environment.graphqlUrl });

      return {
        link: authLink.concat(http),
        cache: new InMemoryCache(),
        defaultOptions: apolloDefaultOptions,
      };
    }),
  ],
};
